export default __webpack_public_path__ + "static/media/real.b2d15b70.jpg";